'use strict';

import bootstrapCss from 'bootstrap/dist/css/bootstrap.min.css';
import neuCss from '../css/main.css';
import bridgeCss from '../css/legacy-tailwind-bridge.css';
import shimCss from '../css/legacy-tw-shim.css';
import { createStyleSheetController } from './cssPacks.js';

function createCssPackSheets() {
  return {
    bs: createStyleSheetController(bootstrapCss, 'bf-css-bs'),
    neu: createStyleSheetController(neuCss, 'bf-css-neu'),
    bridge: createStyleSheetController(bridgeCss, 'bf-css-bridge'),
    shim: createStyleSheetController(shimCss, 'bf-css-shim')
  };
}

export { createCssPackSheets };
